import React, { useEffect, useState } from 'react';
import { Card, message, Button, Modal, Alert } from 'antd';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import DottedLoader from '../../DottedLoader';
import QuotaContext from "../../ContextFiles/QuotaContext";
import UsageQuotaDetail from './UsageQuotaDetail';
import SubscriptionDetails from '../PricingModals/components/SubscriptionDetails/SubscriptionDetails';
import SubscriptionUpgradeManager from '../SubscriptionUpgradeManager/SubscriptionUpgradeManager';
import ContractActivationAndPayment from '../PricingModals/components/ContractActivationAndPayment/ContractActivationAndPayment';
import CancelSubscription from '../PricingModals/components/CancelSubscription/CancelSubscription';
import CancelEnterpriseSubscription from '../PricingModals/components/CancelEnterpriseSubscription/CancelEnterpriseSubscription';
import ManageEnterpriseSubscription from '../PricingModals/components/ManageEnterpriseSubscription/ManageEnterpriseSubscription';
import EnterpriseCreditPurchase from '../PricingModals/components/EnterpriseCreditPurchase/EnterpriseCreditPurchase';
import { plans, bundles, nextSubscription } from '../PricingModals/data/data';
import PricingPlans from '../PricingModals/components/PricingPlans/PricingPlans';
import BuyCreditsModal from '../PricingModals/components/BuyCreditsModal/BuyCreditsModal';
import SuccessModal from '../../SuccessModal/SuccessModal';
import PaymentFailureModalV2 from '../SubscriptionUpgradeManager/PaymentFailureModalV2';
import * as Utilities from '../../Utilities';
import './SubscriptionUsageDetails.scss';
import EnterpriseUsageDetails from './EnterpriseUsageDetails';

export default function SubscriptionUsageDetails({ updateUserAccountInformation }) {

    const [usageDetails, setUsageDetails] = useState([]);
    const [planData, setPlanData] = useState(null);
    const [subscriptionPlan, setSubscriptionPlan] = useState("")
    const [loader, setLoader] = useState(true);
    const [subscriptionCancelled, setSubscriptionCancelled] = useState(false);
    const [cancelSubscriptionModal, setCancelSubscriptionModal] = useState(false);
    const [cancelEnterpriseSubscriptionModal, setCancelEnterpriseSubscriptionModal] = useState(false);
    const [manageEnterpriseSubscriptionModal, setManageEnterpriseSubscriptionModal] = useState(false);
    const [isSubscriptionActive, setIsSubscriptionActive] = useState(false);
    const [selfServeOffersModal, setSelfServeOffersModal] = useState(false);
    const [subscriptionUpgradeManagerModel, setSubscriptionUpgradeManagerModel] = useState(false);
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState("ai_creator");
    const [paymentConfirmationModal, setPaymentConfirmationModal] = useState(false);
    const [cardStatus, setCardStatus] = useState(0);
    const [cancelSubscriptionLoader, setCancelSubscriptionLoader] = useState(false);
    const [paymentFailure, setPaymentFailure] = useState(false);
    const [selectedPlanDetails, setSelectedPlanDetails] = useState(null);
    const [manageSubscriptionModal, setManageSubscriptionModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState("subscriptions");
    const [upgradedModal, setUpgradedModal] = useState(false);
    const [creditPurchaseModal, setCreditPurchaseModal] = useState(false);
    const [creditPurchaseData, setCreditPurchaseData] = useState(null);
    const [buyCreditsModalVisible, setBuyCreditsModalVisible] = useState(false);
    const [subscriptionAvailedEntities, setSubscriptionAvailedEntities] = useState([]);
    const [contractDetails, setContractDetails] = useState(null);
    const [subscriptionStatus, setSubscriptionStatus] = useState(null);
    const [pendingContractActivation, setPendingContractActivation] = useState(false);
    const [contractActivationModal, setContractActivationModal] = useState(false);
    const [contractSuccessModalVisible, setContractSuccessModalVisible] = useState(false);
    const [contractPaymentProcessing, setContractPaymentProcessing] = useState(false);
    const [contractPartialCreditsGiven, setContractPartialCreditsGiven] = useState(0);


    let onCancelSubscription = () => {
        setCancelSubscriptionLoader(true);
        let payload = {
            username: localStorage.getItem('username'),
            auto_renew_subscription: false
        }
        axios.post(ENVIRONMENT.UPDATE_CUSTOMERS_SETTINGS, payload)
            .then(() => {
                setCancelSubscriptionModal(false)
                setSubscriptionCancelled(false);
                setCancelSubscriptionLoader(false);
                message.success('Your subscription is cancelled successfully');
            });
    }

    useEffect(() => {
        loadUserCurrentPlanDetails();
        loadUserContract();
    }, [])

    const loadUserContract = () => {
        let payload = {
            "action": "get_company_latest_contract",
            "company_id": localStorage.getItem('company_id')
        }

        axios.post(ENVIRONMENT.CUSTOMER_CONTRACT_CONTROLLER, payload)
            .then(res => {
                console.log("contract", res.data)
                if(res && res.data){
                    setContractDetails(res.data);
                    if(res.data && 'payment_due_on' in res.data && res.data['payment_due_on'] === null){
                        // First payment was never made, so contract is pending activation
                        // Currently this is only for AI contracts
                        setPendingContractActivation(true);
                    }
                }
            })
    } 
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('buyCreditsModal') === 'true') {
            setBuyCreditsModalVisible(true);
        }
        if (searchParams.get('openPricingModal') === 'true') {
            const planType = searchParams.get('plan_type');
            setSelectedPlan(planType === 'bundle' ? 'bundles' : 'subscriptions');
            setSubscriptionUpgradeManagerModel(true);
        }
    }, [])

    const loadUserCurrentPlanDetails = () => {
        setLoader(true);
        loadUserRequestStatus();
        let payload = {
            'customer_username': localStorage.getItem('username')
        }

        axios.post(ENVIRONMENT.GET_USER_SUBSCRIPTION_DETAILS, payload)
            .then(res => {
                if (res && res['data']) {
                    setUsageDetails(res['data']);
                    setSubscriptionAvailedEntities(res['data']['availed_entities'] ?? [])
                    let plan_payload = {
                        "data": "subscription-plan",
                        "username": localStorage.getItem('username'),
                    }
                    axios.post(ENVIRONMENT.GET_UPDATE_SUBSCRIPTION_DATA, plan_payload)
                        .then(res => {
                            console.log("plan data", res.data)
                            setPlanData(res.data)
                            setSubscriptionPlan(res.data['name'])
                            setIsSubscriptionActive(res.data['is_active']);
                            setSubscriptionCancelled(res.data['auto_renew_subscription'])
                            setSubscriptionStatus(res.data['subscription_status'])
                            setLoader(false);
                        });

                }
            })
            .catch(error => {
                console.log('ERROR = ', error)
                message.error('Something went wrong. Please try again.')
            })
    }

    const loadUserRequestStatus = () => {
        let payload = {
            "username": localStorage.getItem('username'),
            "request_type": "ai_model",
            "action": "check",
            "category": ""
        }
        axios.post(ENVIRONMENT.PAYMENT_GATEWAY, payload)
            .then(res => {
                setCardStatus(res.data['card_status'])
            });
    }

    const upgradeSubscriptionPlan = () => {
        const payload = {
            username: localStorage.getItem("username"),
            subscription_type: selectedSubscriptionPlan,
        };
        axios
            .post(ENVIRONMENT.UPGRADE_SUBSCRIPTION, payload)
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => { });
    };

    const openPaymentConfirmationModal = (offering_plan) => {
        setSelfServeOffersModal(false);
        setSelectedSubscriptionPlan(offering_plan);
        setPaymentConfirmationModal(true);
    }

    const handleRetryPayment = () => {
        setPaymentFailure(false);
        setSubscriptionUpgradeManagerModel(true);
    }

    const getSubscriptionDate = (date) => {
        return new Date(Date.parse(date)).toLocaleString('en-us', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    useEffect(() => {
        if (planData) {
            const displayName = planData['display_name'].replace('ALL3D ', '');
            let selected = plans.filter(item => item.title == displayName)[0];
            if (!selected) {
                selected = bundles.filter(item => item.title == displayName)[0];
            }
            setSelectedPlanDetails(selected);
        }
    }, [planData]);


    const openPricingPlansModal = (type) => {
        setSelectedPlan(type);
        setSubscriptionUpgradeManagerModel(true);
    }

    const openUpgradeModal = () => {
        const displayName = planData?.display_name?.replace('ALL3D ', '');
        if (planData && nextSubscription[displayName]) {
            const nextPlanTitle = nextSubscription[displayName].name;

            // Find the next tier plan details
            let selected = plans.filter(item => item.title == nextPlanTitle)[0];
            if (!selected) {
                selected = bundles.filter(item => item.title == nextPlanTitle)[0];
            }

            if (selected) {
                setSelectedPlanDetails(selected);
                setUpgradedModal(true);
                setManageSubscriptionModal(true);
            }
        }
    }


    const manageSubscription = () => {
        console.log('plandata = ', planData)
        console.log('plans = ', plans)
        if (planData) {
            const displayName = planData['display_name'].replace('ALL3D ', '');
            let selected = plans.filter(item => item.title == displayName)[0];
            if (!selected) {
                selected = bundles.filter(item => item.title == displayName)[0];
            }
            setSelectedPlanDetails(selected);
        }

        setManageSubscriptionModal(true);
    }

    const closeManageSubscriptionModal = () => {
        setManageSubscriptionModal(false);
        setUpgradedModal(false);
    }

    const upgradeSubscription = (plan_name) => {
        if (planData) {
            let selected = plans.filter(item => item.title == plan_name)[0];
            if (!selected) {
                selected = bundles.filter(item => item.title == plan_name)[0];
            }
            console.log("selected", selected)
            setSelectedPlanDetails(selected);
            setUpgradedModal(true);
        }
    }


    const cancelSubscription = () => {
        if (planData?.name === 'custom_contract' || planData?.name === 'custom_contract_ai') {
            setCancelEnterpriseSubscriptionModal(true);
        } else {
            setCancelSubscriptionModal(true);
        }
    }

    const manageEnterpriseSubscription = () => {
        setManageEnterpriseSubscriptionModal(true);
    }

    const closeCancelSubscriptionModal = () => {
        setCancelSubscriptionModal(false);
    }

    const closeCancelEnterpriseSubscriptionModal = () => {
        setCancelEnterpriseSubscriptionModal(false);
    }

    const closeManageEnterpriseSubscriptionModal = () => {
        setManageEnterpriseSubscriptionModal(false);
    }

    const handleViewContract = () => {
        window.location.href = `/customer_contract_form?action=view&contract_id=${contractDetails['id']}`
    }

    const handleBuyCredits = (creditData) => {
        console.log('SubscriptionUsageDetails: handleBuyCredits called', creditData);
        setManageEnterpriseSubscriptionModal(false);
        setCreditPurchaseData(creditData);
        setCreditPurchaseModal(true);
    }

    const handleContactSales = () => {
        // TODO: Implement contact sales functionality
        console.log('Contact sales clicked');
        window.open('mailto:sales@all3d.ai', '_blank');
    }

    const handleRequestCancelEnterprise = () => {
        // TODO: Implement request cancellation for enterprise
        message.info('A cancellation request has been sent to your account manager');
        setCancelEnterpriseSubscriptionModal(false);
        setManageEnterpriseSubscriptionModal(false);
    }

    const handleCancelFromManage = () => {
        setManageEnterpriseSubscriptionModal(false);
        setCancelEnterpriseSubscriptionModal(true);
    }

    const handleActivateContract = () => {
        setContractActivationModal(true);
    }
    const usageOrder = ['ai_models', 'ai_model', 'ai_image_1k', 'ai_image_4k', 'ai_video'];
    const isFreeTrialPlan = planData?.display_name === 'Free Trial';
    const usageSections = [
        { title: 'Credits', items: ['ai_models'] },
        { title: 'Images', items: ['ai_image_4k', 'ai_video'] },
    ];
    const visibleUsageSections = usageSections.filter(section => section.items.length > 0);

    const renderUsageDetail = (itemKey) => {
        const usageIndex = Math.max(usageOrder.indexOf(itemKey), 0);
        return (
            <div className='subscription-usage-item' key={itemKey}>
                <QuotaContext.Provider
                    value={{
                        key: 'Usage Details',
                        item: itemKey,
                        index: usageIndex,
                        quota_details: usageDetails,
                        plan_data: planData,
                        openPricingPlansModal: openPricingPlansModal,
                        openUpgradeModal: openUpgradeModal
                    }}>

                    <UsageQuotaDetail />

                </QuotaContext.Provider>
            </div>
        );
    }


    return (
        <>
            {loader && usageDetails.length == 0 ? (
                <DottedLoader />
            )
                : (
                    <>
                        {planData &&
                            <>
                            {subscriptionStatus == 'payment_pending' &&
                            <div style={{
                                backgroundColor: 'red',
                                padding: '16px',
                                borderRadius: '8px',
                                marginBottom: '24px'
                            }}>
                                <div style={{ flex: 1, minWidth: '300px' }}>
                                    <div className='manrope f-16 w-700 lh-24 white' style={{ marginBottom: '4px' }}>
                                        Automatic Renewal Failed.
                                    </div>
                                    <div className='manrope f-14 w-500 lh-22 white'>
                                        Your subscription could not be renewed. Please update your payment information and we will try to renew it again.
                                    </div>
                                </div>
                            </div>
                            }
                            {pendingContractActivation &&
                            <div style={{
                                backgroundColor: 'white',
                                border: '2px solid #1890ff',
                                padding: '16px',
                                borderRadius: '8px',
                                marginBottom: '24px'
                            }}>
                                <div className='justify-in-between' style={{ alignItems: 'center' }}>
                                    <div>
                                        <div className='manrope f-16 w-600 lh-24 black-085' style={{ marginBottom: '4px' }}>
                                            Contract Pending Activation
                                        </div>
                                        <div className='manrope f-14 w-500 lh-22 black-085'>
                                            You have an inactive contract, make the payment to activate the contract and have access to the platform.
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', gap: '12px' }}>
                                        <Button 
                                            className="manrope f-14 w-500 lh-22 ai-action-btn" 
                                            onClick={handleViewContract}
                                        >
                                            View Contract
                                        </Button>
                                        <Button 
                                            className='modal-okay square border-none manrope f-14 lh-22 w-500 white ' 
                                            onClick={handleActivateContract}
                                        >
                                            Activate Contract
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            }
                            <Card loading={loader} className='grey-background' style={{ marginBottom: "24px" }}>
                                <div className='justify-in-between'>
                                    <div>
                                        <div className='manrope f-20 w-600 lh-28 black-085' style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            {(planData['name'] == 'free_trial_ai') ?
                                                (planData['display_name']) :
                                                (planData['display_name'] + (planData['offering_type'] == 'bundle' ? ' Bundle' : ' Subscription'))}
                                            {subscriptionStatus == 'payment_processing' && (
                                                <span className='manrope f-14 w-600 lh-28'>
                                                    (Payment Processing)
                                                </span>
                                            )}
                                        </div>
                                        <div className='manrope f-14 w-500 lh-22 black-085'>
                                            {planData['name'] != 'enterprise' ?
                                                planData['is_active'] == true ?
                                                    (planData['name'] == 'free_trial_ai') ?
                                                        <span>Trial ends on {getSubscriptionDate(planData['end_time'])}</span> :
                                                        (planData['offering_type'] == "bundle") ?
                                                            <span>Credits expire on {getSubscriptionDate(planData['end_time'])}</span> :
                                                            <span>
                                                                {subscriptionCancelled ?
                                                                    <span>Renews on {getSubscriptionDate(planData['end_time'])}</span> :
                                                                    <span>Subscription ends on {getSubscriptionDate(planData['end_time'])}</span>}
                                                            </span> :
                                                    <span className='manrope f-14 w-500 lh-22 red'>Expired</span> : 
                                                    ''}
                                        </div>

                                    </div>
                                    {planData['name'] != 'enterprise' &&
                                    <div>
                                        {planData['is_active'] == true &&
                                            planData['offering_type'] != 'bundle' ?
                                            planData['name'] == 'free_trial_ai' ?
                                                <Button className="modal-okay square border-none manrope f-14 lh-22 w-500 white" onClick={() => openPricingPlansModal('subscriptions')}>
                                                    View pricing & plans
                                                </Button> : planData['display_name'] == 'Enterprise' ?
                                                    <div className='justify-in-end'>
                                                        <Button className='manrope f-14 w-500 lh-22 ai-action-btn'
                                                            onClick={manageEnterpriseSubscription}>
                                                            Manage subscription
                                                        </Button>
                                                        <Button className='manrope f-14 w-500 lh-22 ai-action-btn ml-8'
                                                            onClick={() => setBuyCreditsModalVisible(true)}>
                                                            Buy Credits
                                                        </Button>
                                                    </div> :
                                                    <div className='justify-in-end'>
                                                        <div className='manrope f-14 w-700 lh-22 black-085'>
                                                            ${planData['is_annual'] ? planData['annual_price'].toLocaleString() : planData['price'].toLocaleString()} {planData['is_annual'] ? ' billed annually' : ' billed monthly'}
                                                        </div>
                                                        <Button className='manrope f-14 w-500 lh-22 ai-action-btn ml-8'
                                                            onClick={manageSubscription}>
                                                            Manage subscription
                                                        </Button>
                                                        <Button className='manrope f-14 w-500 lh-22 ai-action-btn ml-8' onClick={() => openPricingPlansModal('bundles')}>
                                                            Buy a bundle
                                                        </Button>
                                                    </div>
                                            :
                                            <div className='justify-in-end'>
                                                <div className='manrope f-14 w-700 lh-22 black-085'> {Utilities.imagesPurchasedString('scene_lifestyle_image', usageDetails)}</div>
                                                <Button className='manrope f-14 w-500 lh-22 ai-action-btn ml-8' onClick={() => openPricingPlansModal('subscriptions')}>
                                                    Subscribe & save
                                                </Button>
                                                <Button className='manrope f-14 w-500 lh-22 ai-action-btn ml-8' onClick={() => openPricingPlansModal('bundles')}>
                                                    Buy a bundle
                                                </Button>
                                            </div>}
                                    </div>}
                                </div>
                            </Card>
                            </>}

                        {!loader && planData && (planData['name'] != 'enterprise' && planData['name'] != 'custom_contract') &&
                            <div className='subscription-usage-layout'>
                                <div className='subscription-usage-sidebar'>
                                    <span className='manrope f-18 w-600 lh-26 black-085'>Credits</span>
                                    <span className='manrope f-18 w-600 lh-26 black-085'>Usage</span>
                                </div>
                                <div className='subscription-usage-content' style={{ marginTop: '-35px' }}>
                                    {visibleUsageSections.map((section) => (
                                        <React.Fragment key={section.title}>
                                            <div className='subscription-usage-section'>
                                                <div className='manrope f-16 w-500 lh-26 black-085'>{section.title}</div>
                                                <div className='subscription-usage-items' style={{ marginTop: '30px' }}>
                                                    {section.items.map(renderUsageDetail)}
                                                </div>
                                            </div>
                                            <hr className='subscription-usage-divider' />
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>}

                        {!loader && planData && (planData['name'] === 'custom_contract') &&
                            <EnterpriseUsageDetails 
                                usageDetails={usageDetails}
                                planData={planData}
                                openPricingPlansModal={openPricingPlansModal}
                                openUpgradeModal={openUpgradeModal}
                                onBuyCredits={() => setBuyCreditsModalVisible(true)}
                                subscriptionAvailedEntities={subscriptionAvailedEntities}
                            />
                        }

                        <SubscriptionUpgradeManager
                            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
                            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
                            updateUserAccountInformation={updateUserAccountInformation}
                            cardStatus={cardStatus}
                            loadUserRequestStatus={loadUserCurrentPlanDetails}
                            requestType='subscription_upgrade'
                            currentlyActiveSubscription={planData?.is_active ? planData['name'] : null}
                            currentPlanPage={true}
                            selectedPlan={selectedPlan}

                            // the following attributes are only for subscription manage modal (SubscriptionDetails)
                            upgradedModal={upgradedModal}
                            upgradeSubscription={upgradeSubscription}
                            isAnnual={planData?.is_annual}
                            openPricingPlansModal={openPricingPlansModal}
                            manageSubscriptionModal={manageSubscriptionModal}
                            closeManageSubscriptionModal={closeManageSubscriptionModal}
                            selectedPlanDetails={selectedPlanDetails}
                            cancelSubscription={cancelSubscription}
                        //////////////
                        />

                        <Modal
                            className="plan-activation-modal"
                            width={520}
                            destroyOnClose
                            visible={contractActivationModal}
                            closable
                            onCancel={() => setContractActivationModal(false)}
                        >
                            <ContractActivationAndPayment
                                contractDetails={contractDetails}
                                cardStatus={cardStatus}
                                closeSubscriptionUpgrade={() => setContractActivationModal(false)}
                                loadUserRequestStatus={loadUserCurrentPlanDetails}
                                setSuccessModalVisible={setContractSuccessModalVisible}
                                setShowPaymentFailureModal={() => setPaymentFailure(true)}
                                setSystemErrorModal={() => message.error('Something went wrong. Please try again.')}
                                setSubscriptionPaymentProcessing={setContractPaymentProcessing}
                                setPartialCreditsGiven={setContractPartialCreditsGiven}
                                onSuccess={() => {
                                    setPendingContractActivation(false);
                                    loadUserContract();
                                    loadUserCurrentPlanDetails();
                                }}
                            />
                        </Modal>

                        <SuccessModal
                            visible={contractSuccessModalVisible}
                            heading={contractPaymentProcessing && contractPartialCreditsGiven ? 'Payment Initiated' : 'Contract Activated Successfully'}
                            text={
                                contractPaymentProcessing && contractPartialCreditsGiven ? (
                                    <span>
                                        Payment processing initiated. We've granted you <strong>{contractPartialCreditsGiven}%</strong> of your monthly credits to use immediately!
                                        <br /><br />
                                        Remaining credits unlock once payment clears. Close this window and proceed. To view details, <a href="/account-details?tab=subs" target="_blank">click here</a>.
                                    </span>
                                ) : (
                                    <span>You can close this popup and proceed with your request. To view your subscription and usage details, <a href="/account-details?tab=subs" target="_blank">click here</a>.</span>
                                )
                            }
                            footer={[
                                <div className="justify-in-center">
                                    <Button style={{ margin: "auto" }} className="modal-okay square font-14" htmlType="submit" onClick={() => {
                                        setContractSuccessModalVisible(false);
                                    }}>
                                        Okay
                                    </Button>
                                </div>
                            ]}
                        />

                        <CancelSubscription
                            cancelLoader={cancelSubscriptionLoader}
                            openPricingPlansModal={openPricingPlansModal}
                            visible={cancelSubscriptionModal}
                            onClose={closeCancelSubscriptionModal}
                            confirmCancellation={onCancelSubscription}
                            viewPlans={cancelSubscription}
                        />

                        <PaymentFailureModalV2
                            paymentFailureModal={paymentFailure}
                            setPaymentFailureModal={setPaymentFailure}
                        />

                        <ManageEnterpriseSubscription
                            visible={manageEnterpriseSubscriptionModal}
                            onClose={closeManageEnterpriseSubscriptionModal}
                            onViewContract={handleViewContract}
                            onBuyCredits={handleBuyCredits}
                            onContactSales={handleContactSales}
                            onCancelSubscription={handleCancelFromManage}
                        />

                        <CancelEnterpriseSubscription
                            visible={cancelEnterpriseSubscriptionModal}
                            onClose={closeCancelEnterpriseSubscriptionModal}
                            confirmCancellation={handleRequestCancelEnterprise}
                            cancelLoader={cancelSubscriptionLoader}
                            onContactSales={handleContactSales}
                        />

                        <BuyCreditsModal
                            visible={buyCreditsModalVisible}
                            onClose={() => setBuyCreditsModalVisible(false)}
                            onConfirm={handleBuyCredits}
                            planData={planData}
                        />

                        <Modal
                            className="collaborate-access-modal"
                            width={700}
                            destroyOnClose
                            visible={creditPurchaseModal}
                            closable={false}
                            maskClosable={false}
                            onCancel={() => {
                                setCreditPurchaseModal(false);
                                setCreditPurchaseData(null);
                            }}
                            footer={null}>
                            {creditPurchaseData && (
                                <EnterpriseCreditPurchase
                                    creditPurchaseData={creditPurchaseData}
                                    cardStatus={cardStatus}
                                    updateUserAccountInformation={updateUserAccountInformation}
                                    loadUserRequestStatus={loadUserCurrentPlanDetails}
                                    onClose={() => {
                                        setCreditPurchaseModal(false);
                                        setCreditPurchaseData(null);
                                        setBuyCreditsModalVisible(false);
                                    }}
                                    setSuccessModalVisible={() => message.success('Credits purchased successfully!')}
                                    setShowPaymentFailureModal={() => setPaymentFailure(true)}
                                    setSystemErrorModal={() => message.error('Something went wrong. Please try again.')}
                                    planData={planData}
                                />
                            )}
                        </Modal>

                        {/* <SelfServeOffers selfServeOffersModal={selfServeOffersModal} setSelfServeOffersModal={setSelfServeOffersModal} openPaymentConfirmationModal={openPaymentConfirmationModal}/>
                        <Modal
                        className="collaborate-access-modal"
                        width={600}
                        destroyOnClose
                        visible={paymentConfirmationModal}
                        closable
                        onCancel={() => setPaymentConfirmationModal(false)}
                        title={<span className="manrope f-16">Payment Confirmation</span>}
                        >
                        <PlanActivationAndPayment selectedPlanName={selectedSubscriptionPlan} signUpFlow={false} />
                    </Modal> */}
                    </>
                )
            }
        </>
    )
}